import { StaticOrientation } from '@core/enums/statics.enum'
import { STATIC_ORIENTATION_MAP } from '@core/constants/assets.constants'
import { ParsedStatics, StaticAsset, StaticSearchCriteria } from '@core/models/assets.models'
import { exists } from '@mediacoach/ui'

export const parseStatic = (statics: StaticAsset[], orientation: StaticOrientation): string | undefined =>
  ((statics || []).find((staticAsset) => staticAsset.orientation === orientation) || {}).url

export const parseStatics = (statics: StaticAsset[], orientations: StaticOrientation[]): ParsedStatics =>
  orientations.reduce(
    (obj, orientation) => ({
      ...obj,
      [STATIC_ORIENTATION_MAP[orientation] || STATIC_ORIENTATION_MAP.default]: parseStatic(statics, orientation)
    }),
    {}
  )

export const getStaticItem = (statics: StaticAsset[], predicate: (staticItem: StaticAsset) => boolean) =>
  statics.find((s) => predicate(s))?.url

export const findStatic = (statics: StaticAsset[], criteria: StaticSearchCriteria): StaticAsset => {
  return statics?.find((item) => {
    const colorMatch = !exists(criteria.isColor) || item.isColor === criteria.isColor
    const sizeMatch = !criteria.size || item.size === criteria.size
    const orientationMatch = !criteria.orientation || item.orientation === criteria.orientation

    return sizeMatch && orientationMatch && colorMatch
  })
}

export const findStaticWithPriority = (
  items: StaticAsset[],
  criteriaList: StaticSearchCriteria[]
): StaticAsset | undefined => {
  for (const criteria of criteriaList) {
    const result = findStatic(items, criteria)
    if (result) {
      return result
    }
  }
  return undefined
}

export const findStaticUrl = (statics: StaticAsset[], criteria: StaticSearchCriteria): string =>
  findStatic(statics, criteria)?.url

export const findStaticUrlWithPriority = (statics: StaticAsset[], criteriaList: StaticSearchCriteria[]): string =>
  findStaticWithPriority(statics, criteriaList)?.url
